import { ActionType, createAction } from 'typesafe-actions';
import { PowerBIReportDescription } from '../../lib/api/types/PowerBIReportDescription';
import { GetEmbedInfoForReportResponse } from '../../lib/api/types/GetEmbedInfoForReportResponse';
export const PowerBiActions = {
    fetchReportDescriptions: createAction('powerBi/FETCH_REPORT_DESCRIPTIONS')(),
    reportDescriptionsReceived: createAction('powerBi/REPORT_DESCRIPTIONS_RECEIVED')<PowerBIReportDescription[]>(),
    viewReport: createAction('powerBi/VIEW_REPORT')<PowerBIReportDescription>(),
    closeReport: createAction('powerBi/CLOSE_REPORT')(),
    embedInfoReceived: createAction('powerBi/EMBED_INFO_RECEIVED')<GetEmbedInfoForReportResponse>(),
    reportLoaded: createAction('powerBi/REPORT_LOADED')(),
};
export type PowerBiActions = ActionType<typeof PowerBiActions>;
